import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as viewReducer from "containers/View/reducer";
import * as createReducer from "containers/CreateWizard/reducer";
import * as globalReducer from "containers/App/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as marketplaceReducer from "containers/Marketplace/reducer";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";
import * as setupReducer from "containers/Setup/reducer";

import BlueprintRow from "components/View/Rows/BlueprintRow";

import BlueprintTile from "components/Tiles/BlueprintTile.js";

import { isEnabled } from "utils/featureFlags";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as projectReducer from "containers/Project/reducer";

class ChatBlueprintItemContainer extends React.PureComponent {
  handleClick(data) {
    const {
      history,
      updateStep,
      onClick,
      updateDatasetId,
      resetDataset,
      updateBlueprint,
      handleSelectUseCase,
      resetSearch
    } = this.props;

    const isAdvanced = isEnabled("aible-advanced");

    if (onClick !== undefined) {
      return onClick(data.id);
    } else {
      return handleSelectUseCase(data.id);
    }
  }

  renderTile() {
    const {
      index,
      data,
      handleDelete,
      onClick,
      onEditClick,
      noClick,
      onHover,
      style,
      history,
      setBlueprint,
      updateHoverBlueprint,
      updateIsEditBlueprint,
      handleSelectUseCase,
      hideEdit,
      isNext,
      canDelete,
      ...retProps
    } = this.props;

    const retOnClick = onClick ? () => onClick(data.id) : noClick ? undefined : () => this.handleClick(data);

    const retHandleDelete = noClick || !canDelete ? undefined : handleDelete;

    return (
      <div style={style}>
        {
          <BlueprintTile
            {...retProps}
            blueprint={data}
            onClick={retOnClick}
            onClickLabel={"Use Chat Style"}
            handleDelete={retHandleDelete}
            onHover={(id) => updateHoverBlueprint(id)}
            key={index}
            noDescriptionLabel
          />
        }
      </div>
    );
  }

  renderRow() {
    const { index, data, dataset, isHighlight, updateHoverBlueprint } = this.props;

    return (
      <BlueprintRow
        blueprint={data}
        dataset={dataset}
        onHover={(id) => updateHoverBlueprint(id)}
        isHighlight={isHighlight}
        key={index}
      />
    );
  }

  render() {
    const { isTile } = this.props;

    return isTile ? this.renderTile() : this.renderRow();
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchNext: () => dispatch(blueprintReducer.fetchNextBlueprints()),

  setBlueprint: (runId, blueprintId) => dispatch(blueprintReducer.setBlueprint(runId, blueprintId)),

  updateStep: (runId) => dispatch(createReducer.updateStep(runId)),

  updateHoverBlueprint: (id) => dispatch(globalReducer.updateHoverBlueprint(id)),

  updateActiveBlueprintId: (blueprintId) => dispatch(globalReducer.updateActiveBlueprintId(blueprintId)),

  handleDelete: () => dispatch(blueprintReducer.handleDelete(ownProps.id)),

  updateBlueprint: (id, obj) => dispatch(blueprintReducer.updateBlueprint(id, obj)),

  getOriginalAuthor: (id) => dispatch(marketplaceReducer.getOriginalAuthor(id)),

  updateDatasetId: (datasetId) => dispatch(setupReducer.updateDatasetId("new", datasetId)),

  resetSearch: () => dispatch(viewReducer.updateSearch(undefined)),

  handleSelectUseCase: (blueprintId) => dispatch(chatGPTReducer.handleSelectUseCase(blueprintId)),

  updateIsEditing: (blueprintId, isEditing) => dispatch(blueprintReducer.updateIsEditing(blueprintId, isEditing)),

  updateMoveBlueprintId: (blueprintId) => dispatch(foldersReducer.updateMoveBlueprintId(blueprintId)),

  updateIsEditBlueprint: (projectId, isEditing) =>
    dispatch(unifiedProjectReducer.updateIsEditBlueprint(projectId, isEditing, false, true))
});

const mapStateToProps = (state, ownProps) => {
  const highlight = globalReducer.getHoverItem(state);

  const originalDatasetId = blueprintReducer.getOriginalDatasetId(state, ownProps.id);
  const currentNextId = nextReducer.getCurrentNextId(state);
  const currentProjectId = nextReducer.getProjectId(state, currentNextId);

  return {
    data: blueprintReducer.getBlueprint(state, ownProps.id),

    dataset: blueprintReducer.getOriginalDataset(state, ownProps.id),

    linkedDatasets: blueprintReducer.getLinkedDatasetsArr(state, ownProps.id),

    datasetType: blueprintReducer.getOutcomeTypeFromBlueprint(state, ownProps.id),

    customFields: blueprintReducer.getCustomFieldsTransformed(state, ownProps.id),

    isTile: ownProps.isTile ? ownProps.isTile : viewReducer.getIsTile(state),
    type: viewReducer.getType(state),

    isLoading: globalReducer.getIsBlueprintsLoading(state),

    isHighlight: highlight && highlight.hoverType === "DATASET" ? highlight.id === originalDatasetId : false,

    canDelete: blueprintReducer.getUserDeletePermission(state, ownProps.id),

    optimized: projectReducer.getOptimized(state, currentProjectId),
    segmentSetups: projectReducer.getSegmentSetups(state, currentProjectId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ChatBlueprintItemContainer);
